import React, { useCallback, useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { UserCog } from "lucide-react";

const NONE = "__not_assigned__";

export function ProgramSupportPanel({ personId }) {
  const [d, setD] = useState(null);
  const load = useCallback(() => { api.get(`/persons/${personId}/program-support`).then((r) => setD(r.data)).catch(() => setD(null)); }, [personId]);
  useEffect(() => { load(); }, [load]);
  if (!d) return null;
  const save = async (role, v) => {
    try {
      const r = (await api.put(`/persons/${personId}/program-support`, { [role]: v === NONE ? null : v })).data;
      const n = r.tasks_moved?.[role] || 0;
      toast.success(`Program Support updated${n ? ` · ${n} open task${n === 1 ? "" : "s"} ${v === NONE ? "unassigned" : "moved"}` : ""}`);
      load();
    } catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-5" data-testid="program-support-panel">
      <div className="flex items-center gap-2 mb-1">
        <span className="w-8 h-8 rounded-lg bg-[#006090]/10 text-[#006090] flex items-center justify-center"><UserCog className="w-4 h-4" /></span>
        <h3 className="font-display font-semibold text-slate-900">Program Support</h3>
      </div>
      <p className="text-xs text-slate-500 mb-3">Program tasks for each responsibility go to the person named here. Not Assigned keeps them out of everyone's personal Task list.</p>
      <div className="space-y-2">
        {d.roles.map((r) => (
          <div key={r.role} className="grid grid-cols-2 gap-3 items-center">
            <span className="text-sm text-slate-700">{r.label}</span>
            {d.can_edit && !r.synced_with_recruiter ? (
              <Select value={r.user_id || NONE} onValueChange={(v) => save(r.role, v)}>
                <SelectTrigger className="h-9" data-testid={`ps-${r.role}`}><SelectValue /></SelectTrigger>
                <SelectContent className="bg-white max-h-72">
                  <SelectItem value={NONE}>Not Assigned</SelectItem>
                  {(r.options || d.users).map((u) => <SelectItem key={u.user_id} value={u.user_id}>{u.name}</SelectItem>)}
                </SelectContent>
              </Select>
            ) : null}
            {d.can_edit && !r.synced_with_recruiter && r.role === "support_staff" && !(r.options || []).length && (
              <span className="col-span-2 text-[11px] text-slate-400" data-testid="ps-support-empty">No one is on this group's Support Staff list yet. Add them in Recruiting → My Team.</span>
            )}
            {d.can_edit && !r.synced_with_recruiter ? null : <span className="text-sm text-slate-600" data-testid={`ps-${r.role}`}>{r.user_name || "Not Assigned"}{r.synced_with_recruiter && <span className="block text-[11px] text-slate-400" data-testid="ps-recruiter-synced">Same as Assigned Recruiter. Change the recruiter to update it.</span>}</span>}
          </div>))}
      </div>
    </div>
  );
}
